import { Component, Injectable, Inject, ViewChild, OnInit } from '@angular/core';
import { CommonFunctionsService } from '@angular/synthrone-design/services';
import {
  ApiService,
  AuthenticateService,
  EndpointService,
  CookieService,
  LocalStorageService,
  VirtualStorageService,
  PermissionsService
} from '@angular/synthrone-design/services';
import { Observable } from 'rxjs/Observable';
import { environment } from '@synthroneEnvironments/environment';
import { ActivatedRoute, Params, Router } from "@angular/router";
import { ClientServiceSDK } from 'ms-client-angular-sdk';
import { UserServiceSDK } from 'ms-user-angular-sdk';

@Component({
  selector: 'users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})

export class UsersViewComponent implements OnInit {

  @ViewChild('usersTable') usersTable;

  loading = false;

  selectedOrganization;
  organizations;
  oldOrganizations;

  configColumns = {
    avatar: {
      label: '',
      style: {
        width: '35px',
        flex: 'none',
        paddingRight: '20px'
      },
      type: 'userAvatar'
    },
    name: {
      label: 'Name',
      sortable: true,
      truncate: true
    },
    email: {
      label: 'Email',
      sortable: true,
      truncate: true
    },
    lastLogin: {
      label: 'Last login',
      sortable: true,
      type: 'timeAgo'
    }
  };

  queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
  timeout = null;
  tableFilter = {
    'search': ''
  };
  clientUsers: any[] = [];

  constructor(@Inject(CommonFunctionsService) public commonFunctions,
              private _router: Router,
              private route: ActivatedRoute,
              private api: ApiService,
              private cookieService: CookieService,
              private authenticateService: AuthenticateService,
              private lsService: LocalStorageService,
              private virtualService: VirtualStorageService,
              private endpointService: EndpointService,
              private clientService: ClientServiceSDK,
              private userService: UserServiceSDK,
              private permissionsService: PermissionsService) {
  }

  ngOnInit() {
      this.api.makeSDKRequest(this.clientService, "clientsGet").subscribe((res) => {
        this.organizations = res.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
        this.selectedOrganization = this.organizations.find((organization) => {
          if (organization.name) {
            return organization;
          }
        }).planet;
        this.getClientUsers(this.selectedOrganization);
      });
    this.tableFilter = {
      'search': (typeof this.queryParams['search'] === "undefined") ? this.tableFilter.search : this.queryParams['search']
    }
  }

  setParams = () => {
    this.queryParams['search'] = this.tableFilter.search;
  }

  refreshTable = () => {
    this.usersTable.getData()
  }

  loginAsFN = (userHash, clientPlanet, name, email) => {
    const timestamp = (new Date()).getTime();
    const managerWindow = window.open('about:blank', 'managerBlank' + timestamp);
    this.api.makeSDKRequest(this.userService, "getUserImpersonate", false, userHash).subscribe(response => {
      this.cookieService.removeCookie('appToken');
      this.cookieService.removeCookie('appToken', true);
      this.cookieService.removeCookie('clientPlanet');
      this.cookieService.removeCookie('userInfo');
      this.cookieService.removeCookie('clientAssets');
      this.virtualService.removeItem('userPermissions');


      this.cookieService.setCookie('appToken', response['api-token']);
      this.cookieService.setCookie('appToken', response['api-token'], true);
      this.cookieService.setCookie('clientPlanet', clientPlanet);
    
      Object.assign(this.permissionsService.permissionsServiceSDK.configuration.apiKeys, {'api-token': this.cookieService.getCookie('appToken')});
      
      this.cookieService.setCookie('userInfo', {
        name: name,
        id: userHash,
        email: email,
        planet: clientPlanet
      });

      this.api.makeSDKRequest(this.permissionsService, "getPermissions").subscribe((result) => {
        let permissions = null;
        if (result) {
          permissions = [];
          result.forEach(permission => {
            permissions.push(permission);
          });
          }
        this.virtualService.setItem('userPermissions', permissions);
      })

      this.cookieService.setCookie('clientPlanet', clientPlanet);
      let urlToOpen = (environment.api.https ? 'https://' : 'http://') + clientPlanet + "." + environment.api.manager.host;
      managerWindow.open(urlToOpen, 'managerBlank' + timestamp);
    });
  }

  orgChange = (event) => {
    const selectedOrganization = this.organizations.find((org) => {
      return org.planet === this.selectedOrganization;
    });

    this.getClientUsers(selectedOrganization.planet);
  }

  getClientUsers = (organization) => {
    this.userService.getUsers(organization, 'compact').subscribe(results => {
      this.clientUsers = this.sortResults(results, 'created', 'asc');
      (<any>results).forEach(result => {
        result.__rowConfig = {
          style: {}
        }
        if (result.isOwner == true) {
          result.__rowConfig.style = {
            fontFamily: 'Gotham Bold'
          }
        }
        
      });
      this.usersTable.getData();
    })
  }


  sdUser = (limit, offset, sortBy, sortOrder) => {
    return Observable.of(this.filterResults(this.sortResults(this.clientUsers, sortBy, sortOrder)));
  }

  searchUserByCompanyFN = () => {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.setParams();
      this._router.navigate(['/users/'], {relativeTo: this.route, queryParams: this.queryParams});
      this.refreshTable();
    }, 2000);
  }

  sortResults = (results, sortBy, sortOrder) => {
    if (sortBy) {
      results.sort((a, b) => {
        let aStr = typeof a[sortBy] !== 'string' ? (a[sortBy] === null ? Infinity : a[sortBy]) : a[sortBy].toLowerCase();
        let bStr = typeof b[sortBy] !== 'string' ? (b[sortBy] === null ? Infinity : b[sortBy]) : b[sortBy].toLowerCase();            
        if (aStr < bStr) {
          return -1;
        }
        if (aStr > bStr) {
          return 1;
        }
        return 0;
        })
    }

    if (sortOrder == 'asc') {
      return results;
    } else if (sortOrder == 'desc') {
      return results.reverse();
    }
  }

  filterResults = (results) => {
    return results.filter((result) => result.name.toLowerCase().includes(this.tableFilter.search.toLowerCase()) || result.email.toLowerCase().includes(this.tableFilter.search.toLowerCase()))
  }

}



// WEBPACK FOOTER //
// ./src/app/components/views/users/users.component.ts